import { selectProfileData } from '@pages/profile/store/selectors';
import { useCallback, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

const useUserValidations = () => {
  const navigate = useNavigate();
  const profile = useSelector(selectProfileData);
  const { isFullRegister, isKyc } = profile || {};

  const isUserValid = useMemo(
    () => isFullRegister && isKyc,
    [isFullRegister, isKyc]
  );

  const redirectToOnboarding = useCallback(() => {
    if (!isUserValid) {
      navigate('/onboarding');
    }
  }, [isUserValid, navigate]);

  return { isUserValid, redirectToOnboarding };
};

export default useUserValidations;
